import OrderPrice from './OrderPrice'

export default OrderPrice
